import { useApiGet } from "./Api.hooks";

const endpoint = `/api/tasks`;

export const useGetLastCompletedTasks = () => {
  return useApiGet(`${endpoint}/last-completed`);
};
